// extracted by mini-css-extract-plugin
export default {"root":"_3CAmf","menu-item":"hCvun","menuItem":"hCvun","selected":"_3f4EW"};